import { parseToNumericOnly }       from '../../../utilities/sanitize.js'


export const extractNumericChanges = (orderedCompanyPriceData, cpdActiveFields) => {
    console.log("[ENTERING STEP 1 - NEP TECHNIQUE - ORCHESTRATION BY ASSEMBLER]: Normalization Step")
    console.log(`${"=".repeat(30)}`)

    // The active change off every row, minus the N/A ones (IPO window) - they have no position on a numeric axis
    const changes = orderedCompanyPriceData.map((cpd) => cpd[cpdActiveFields.change])
    return parseToNumericOnly(changes)
}
